/**
 * PATH: packages/ui/src/kanban/card-surface/runtime/useCardCapabilityRuntime.ts
 * FILE_ID: UI-KANBAN-CARDSURFACE-CONTEXT-HOOK-001
 * PURPOSE: Read the optional or required board-scoped card runtime.
 * WHY: Standalone compatibility tiles may omit a provider during staged migration.
 * FLOW: context → nullable runtime or explicit configuration error.
 * DEPENDENCIES: react; cardCapabilityContext.ts.
 * RELATED: CardCapabilityProvider.tsx; projections/CardTileSurface.tsx.
 */
import { useContext } from 'react'

import type { CardSurfaceRuntime } from '../contract'
import { CardCapabilityContext } from './cardCapabilityContext'

export function useOptionalCardSurfaceRuntime(): CardSurfaceRuntime | null {
  return useContext(CardCapabilityContext)
}

export function useRequiredCardSurfaceRuntime(): CardSurfaceRuntime {
  const runtime = useOptionalCardSurfaceRuntime()
  if (runtime) return runtime
  throw new Error(
    'Card surface runtime is missing. Render this projection inside CardCapabilityProvider.',
  )
}
